import request from '../../../axios';

export const postPaymentPromotion = async (
  payload: PaymentPromotionPayload,
) => {
  const {data}: {data: PaymentPromotionData} = await request.post(
    `/api/v2/subscription/payment-promotion`,
    payload,
  );
  return data;
};
